import styled from "styled-components";

import Colors from "@constants/Colors";
import { Card } from "@mui/material";

export const CustomCard = styled(Card)`
  &.MuiPaper-root {
    box-shadow: none;
    background: ${Colors.white};
    padding: 16px;
    box-sizing: border-box;
    border: 1px solid ${Colors.neutral_gray_300};
    border-radius: 8px;
  }
`;
